import React, { useEffect, useState } from "react";
import { useStyles } from "./TakisLanguageToggle.styles";
import { Link, useLocation } from "react-router-dom";
import { useLanguage, supportedLanguages } from "../hooks/useLanguage";
import useFetchGlobalData from "../hooks/useFetchGlobalData";

const LanguageToggle = ({ data }) => {
  const classes = useStyles();
  const language = useLanguage();
  const { pathname } = useLocation();
  const [ hover, setHover ] = useState(false);

  const link = language === supportedLanguages.en
      ? `/${supportedLanguages.es}`
      : "/";

  const linkTitle = language === supportedLanguages.en
      ? 'lea est pagina en español'
      : 'read this page in english';

  // default is home
  const [ targetLink, setTargetLink ] = useState({link});
  const [ targetTitle, setTargetTitle ] = useState(linkTitle);

  const {
    // error,
    // isLoading,
    localeGlobalData: esLocaleGlobalData
  } = useFetchGlobalData(supportedLanguages.es)

  const {
    // error,
    // isLoading,
    localeGlobalData: enLocaleGlobalData
  } = useFetchGlobalData(supportedLanguages.en)

  const findLink = (linkPath, compareKey, globalLinks) => {
    let foundLink
    globalLinks.find((link) => {
      let found = linkPath === link[compareKey] && link.type !== 'other'
      if (found) {
        foundLink = link
      } else {
        if (link.sub_nav_options.length) {
          link.sub_nav_options.find((subnavLink) => {
            const foundInSublink = subnavLink[compareKey] === linkPath && subnavLink.type !== 'other'
            if (found) {
              foundLink = subnavLink
            }
            return foundInSublink
          })
        }
      }
      return found
    })

    return foundLink
  }

  useEffect(()=> {
    const link = (language === supportedLanguages.en)
      ? `/${supportedLanguages.es}`
      : "/";

    const linkTitle = language === supportedLanguages.en
      ? 'lea este sitio en español (es)'
      : 'read this site in english (en)';

    setTargetLink({link})
    setTargetTitle(linkTitle)

    const isSpanish = language === supportedLanguages.es
    // which is current
    const currentLangData = isSpanish
      ? esLocaleGlobalData
      : enLocaleGlobalData
    // gets oposite
    const targetLangData = isSpanish
      ? enLocaleGlobalData
      : esLocaleGlobalData

    // if it finds refered link
    if (currentLangData && targetLangData) {
      // Filters list of links in site
      const currentLink = findLink(pathname, 'link', currentLangData.header.nav_options)

      // Filters list of links in targetLanguage
      if (currentLink) {
        const foundTargetLink = findLink(currentLink.id, 'id', targetLangData.header.nav_options)

        // Sets Target Link
        if (currentLink && foundTargetLink) {
          // Target found routing toggle
          // to page in the other language.
          setTargetLink(foundTargetLink);
        }
      }
    }

  }, [
    esLocaleGlobalData,
    enLocaleGlobalData,
    language,
    pathname
  ])

  const onMouseOut = () => {
    setHover(false)
  }
  const onMouseOver = () => {
    setHover(true)
  }

  // to change HTML attributes
  const refreshOnLangChange = () => {
    // After Navigation
    setTimeout(()=>{
        window.location.reload(false);
    }, 500);
  }

  return (
    <Link
      className={classes.languageToggleButton}
      // Lands a link Home if no target is found on list from server.
      to={targetLink.link}
      title={targetTitle}
      aria-label={targetTitle}
      onClick={refreshOnLangChange}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      <span className={`
          ${language}
          ${classes.languageToggleLabel}
          ${language === supportedLanguages.es ? 'visible' : ''}
          ${hover ? (language === supportedLanguages.es ? 'out' : 'hover') : ''}
          `}
          >
        { supportedLanguages.es }
      </span>
      <span  className={`
          ${language}
          ${classes.languageToggleLabel}
          ${language === supportedLanguages.en ? 'visible' : ''}
          ${hover ? (language === supportedLanguages.en ? 'out' : 'hover') : ''}
        `}
        >
        { supportedLanguages.en }
      </span>
    </Link>
  );
};


export default LanguageToggle;
